import { ButtonHTMLAttributes, forwardRef, memo } from "react";
import classNames from "classnames";

import { ReactComponent as BurgerIcon } from "./icons/burger.svg";
import { ReactComponent as CloseIcon } from "./icons/close.svg";

import styles from "./styles.module.scss";

export type NavMenuButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> & {
  isMenuOpen: boolean
}

export const NavMenuButton = memo(forwardRef<HTMLButtonElement, NavMenuButtonProps>((
  {
    className,
    isMenuOpen,
    ...props
  },
  ref,
) => {
  return (
    <button
      type="button"
      {...props}
      className={classNames(
        className,
        styles.root,
        isMenuOpen ? styles.close : styles.burger,
      )}
      ref={ref}
    >
      {isMenuOpen ? <CloseIcon /> : <BurgerIcon />}
    </button>
  );
}));